import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDefaultPayment as getDefaultPaymentApi,
  updatePayment as updatePaymentApi,
  getPlanInformation as getPlanInformationApi,
  switchPlan as switchPlanApi,
  cancelPlan as cancelPlanApi,
  unCancelPlan as unCancelPlanApi,
} from "../../apiCalls/caller";

export const getDefaultPayment = createAsyncThunk(
  "billing/getDefaultPayment",
  async (data) => {
    try {
      const response = getDefaultPaymentApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const updatePayment = createAsyncThunk(
  "billing/updatePaymentMethod",
  async (params) => {
    try {
      const response = updatePaymentApi(params);
      const data = await response;

      return data;
    } catch (error) {
      return error;
    }
  }
);

export const getPlanInformation = createAsyncThunk(
  "billing/getPlanInformation",
  async (params) => {
    try {
      const response = getPlanInformationApi(params);
      const data = await response;
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const switchPlan = createAsyncThunk(
  "billing/switchPlan",
  async (params) => {
    try {
      const response = switchPlanApi(params);
      const data = await response;
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const cancelPlan = createAsyncThunk(
  "billing/cancelPlan",
  async (params) => {
    try {
      const response = cancelPlanApi(params);
      const data = await response;
      return data;
    } catch (error) {
      return error;
    }
  }
);

export const unCancelSubscription = createAsyncThunk(
  "billing/unCancelSubscription",
  async (params) => {
    try {
      const response = unCancelPlanApi(params);
      const data = await response;
      return data;
    } catch (error) {
      return error;
    }
  }
);

/*
export const addNewOrder = createAsyncThunk(
  "orders/addNewOrder",
  async (order) => {
    try {
      toast.loading("Sending Order...", {
        position: "top-center",
      });
      const response = addNewOrderApi(order);
      const data = await response;
      toast.dismiss();
      toast.success("Order Placed Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.error("Order Added Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateOrder = createAsyncThunk(
  "orders/updateOrder",
  async (order) => {
    try {
      const response = updateOrderApi(order);
      const data = await response;
      toast.dismiss();
      toast.success("Order Updateded Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.error("Order Updateded Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const cancelOrder = createAsyncThunk(
  "orders/cancelOrder",
  async (order) => {
    try {
      toast.loading("Cancelling Order...", {
        position: "top-center",
      });
      const response = cancelOrderApi(order);
      const data = await response;
      toast.dismiss();
      toast.success("Order Cancelled Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.dismiss();
      toast.error("Order Cancel Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);
*/
